import { render, staticRenderFns } from "./reportHometab.vue?vue&type=template&id=2f4492f5&scoped=true"
import script from "./reportHometab.vue?vue&type=script&lang=js"
export * from "./reportHometab.vue?vue&type=script&lang=js"
import style0 from "./reportHometab.vue?vue&type=style&index=0&id=2f4492f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4492f5",
  null
  
)

export default component.exports